module.exports = __webpack_public_path__ + "img/i12.c06f1bf6.svg";